import { render, staticRenderFns } from "./templates_page.vue?vue&type=template&id=72911816&scoped=true&"
import script from "./templates_page.vue?vue&type=script&lang=js&"
export * from "./templates_page.vue?vue&type=script&lang=js&"
import style0 from "./templates_page.vue?vue&type=style&index=0&id=72911816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72911816",
  null
  
)

export default component.exports